 /* eslint-disable */ 
import {defineStore} from 'pinia'
import CustomStore from "devextreme/data/custom_store";
import {ref} from "vue";
import _ from "lodash";
import axios from "axios";
import {API_BASE_URL} from "@/global-constants";
import api from "@/api";
import { useRoute } from "vue-router";
export const useGajiModel = defineStore(
    'gajiModel',
    () => {
        const route = useRoute();
        const summary = ref(null);
        // const periodeAbsen = DateTime.now().set({ day: 1 }).toFormat("yyyy-MM-dd");
       
        const latestAccessTime = ref(null);
        const direksiCustomStore = new CustomStore({
            load: async (loadOptions) => {
                let params = {};
                if (loadOptions.sort) {
                    if (typeof loadOptions.sort[0].selector === 'function') {
                        loadOptions.sort[0].selector= loadOptions.sort[0].selector.context.column.dataField;//sorting untuk column calculate display
                    }
                    params.sort = JSON.stringify(loadOptions.sort);
               
                    params.sort =  params.sort.replace(/riwayat_pekerjaan/g, 'riwayat_pekerjaans');

                    if (!params.sort.includes("pegawai_status_id")) {
                        params.sort =  params.sort.replace(/pegawai./g, 'simpeg_pegawais.');
                      } 
                      
                }
         
               
                params.summaryFrom = 1;
                
                loadOptions.filter = processLoadArray(loadOptions.filter); //benerin format periode_absen
                if (loadOptions.filter) {
                    let temp = [];
                    const newFilters = [['gajis.pegawai_status_id', '=', 1], "and", ['gaji_periode_id', '=', route.query.id]];
                        if(loadOptions.filter.length>0){
                            loadOptions.filter = [loadOptions.filter, 'and', ...newFilters];
                        }else{
                            loadOptions.filter = newFilters;
                            // loadOptions.filter = [[['gajis.pegawai_status_id', '>', 1], "and", ['gajis.pegawai_status_id', '<', 4]],"and", ['gaji_periode_id', '=', route.query.id]];
                        }


              
                   
                       
                        temp = loadOptions.filter;
                    
                    params.filter = JSON.stringify(temp);
                    params.filter =  params.filter.replace(/riwayat_pekerjaan/g, 'riwayat_pekerjaans');

                    if (!params.filter.includes("pegawai_status_id")) {
                        // params.filter =  params.filter.replace(/pegawai./g, 'simpeg_pegawais.');
                      } 
                }
                if (loadOptions.skip) {
                    params.skip = loadOptions.skip;
                }
                if (loadOptions.take) {
                    params.take = loadOptions.take;
                }

               

                const response = await axios.get(`${API_BASE_URL}/customstore-gajis`, {
                    params: params,
                    headers: {
                        Authorization: api.defaults.headers.common['Authorization'],
                        'Content-Type': 'application/json',
                    },
                });

                
                latestAccessTime.value = null;
                // summary.value = null;
              
                if (response.data) {

                    summary.value = response.data.summary;
                    return {
                        data: response.data.data,
                        totalCount: response.data.totalCount,
                        summary: response.data.summary
                    };
                }

                throw 'Data loading error';
            },
        });

        const tetapCustomStore = new CustomStore({
            load: async (loadOptions) => {
                let params = {};
                params.summaryFrom = 2;
                if (loadOptions.sort) {
                    if (typeof loadOptions.sort[0].selector === 'function') {
                        loadOptions.sort[0].selector= loadOptions.sort[0].selector.context.column.dataField;//sorting untuk column calculate display
                    }
                    params.sort = JSON.stringify(loadOptions.sort);
               
                    params.sort =  params.sort.replace(/riwayat_pekerjaan/g, 'riwayat_pekerjaans');

                    if (!params.sort.includes("pegawai_status_id")) {
                        params.sort =  params.sort.replace(/pegawai./g, 'simpeg_pegawais.');
                      } 
                }
         
               

                
                loadOptions.filter = processLoadArray(loadOptions.filter); //benerin format periode_absen
                if (loadOptions.filter) {
                    let temp = [];
                    const newFilters = [
                        [['gajis.pegawai_status_id', '>', 1], 'and', ['gajis.pegawai_status_id', '<', 4]],
                        'and',
                        ['gaji_periode_id', '=', route.query.id]
                      ];
                        if(loadOptions.filter.length>0){
                            loadOptions.filter = [loadOptions.filter, 'and', ...newFilters];
                        }else{
                            loadOptions.filter = newFilters;
                            // loadOptions.filter = [[['gajis.pegawai_status_id', '>', 1], "and", ['gajis.pegawai_status_id', '<', 4]],"and", ['gaji_periode_id', '=', route.query.id]];
                        }
                        temp = loadOptions.filter;
                    
                    params.filter = JSON.stringify(temp);
                    params.filter =  params.filter.replace(/riwayat_pekerjaan/g, 'riwayat_pekerjaans');

                    if (!params.filter.includes("pegawai_status_id")) {
                        // params.filter =  params.filter.replace(/pegawai./g, 'simpeg_pegawais.');
                      } 
                }
                if (loadOptions.skip) {
                    params.skip = loadOptions.skip;
                }
                if (loadOptions.take) {
                    params.take = loadOptions.take;
                }

               

                const response = await axios.get(`${API_BASE_URL}/customstore-gajis`, {
                    params: params,
                    headers: {
                        Authorization: api.defaults.headers.common['Authorization'],
                        'Content-Type': 'application/json',
                    },
                });

                
                latestAccessTime.value = null;
                // summary.value = null;
              
                if (response.data) {

                    summary.value = response.data.summary;
                    return {
                        data: response.data.data,
                        totalCount: response.data.totalCount,
                        summary: response.data.summary
                    };
                }

                throw 'Data loading error';
            },
        });

        const honorCustomStore = new CustomStore({
            load: async (loadOptions) => {
                let params = {};
                params.summaryFrom = 4;
                if (loadOptions.sort) {
                    if (typeof loadOptions.sort[0].selector === 'function') {
                        loadOptions.sort[0].selector= loadOptions.sort[0].selector.context.column.dataField;//sorting untuk column calculate display
                    }
                    params.sort = JSON.stringify(loadOptions.sort);
               
                    params.sort =  params.sort.replace(/riwayat_pekerjaan/g, 'riwayat_pekerjaans');

                    if (!params.sort.includes("pegawai_status_id")) {
                        params.sort =  params.sort.replace(/pegawai./g, 'simpeg_pegawais.');
                      } 
                }
         
               

                
                loadOptions.filter = processLoadArray(loadOptions.filter); //benerin format periode_absen
                if (loadOptions.filter) {
                    let temp = [];
                        if(loadOptions.filter.length<=0){
                            loadOptions.filter = [['gajis.pegawai_status_id', '=', 4], "and", ['gaji_periode_id', '=', route.query.id]];
                        }
                        temp = loadOptions.filter;
                    
                    params.filter = JSON.stringify(temp);
                    params.filter =  params.filter.replace(/riwayat_pekerjaan/g, 'riwayat_pekerjaans');

                  //  if (!params.filter.includes("pegawai_status_id")) {
                        // params.filter =  params.filter.replace(/pegawai./g, 'simpeg_pegawais.');
                     // } 
                }
                if (loadOptions.skip) {
                    params.skip = loadOptions.skip;
                }
                if (loadOptions.take) {
                    params.take = loadOptions.take;
                }

               

                const response = await axios.get(`${API_BASE_URL}/customstore-gajis`, {
                    params: params,
                    headers: {
                        Authorization: api.defaults.headers.common['Authorization'],
                        'Content-Type': 'application/json',
                    },
                });

                
                latestAccessTime.value = null;
                // summary.value = null;
              
                if (response.data) {

                    summary.value = response.data.summary;
                    return {
                        data: response.data.data,
                        totalCount: response.data.totalCount,
                        summary: response.data.summary
                    };
                }

                throw 'Data loading error';
            },
        });

        const kontrakCustomStore = new CustomStore({
            load: async (loadOptions) => {

                let params = {};
                params.summaryFrom = 5;
                if (loadOptions.sort) {
                    if (typeof loadOptions.sort[0].selector === 'function') {
                        loadOptions.sort[0].selector= loadOptions.sort[0].selector.context.column.dataField;//sorting untuk column calculate display
                    }
                    params.sort = JSON.stringify(loadOptions.sort);
               
                    params.sort =  params.sort.replace(/riwayat_pekerjaan/g, 'riwayat_pekerjaans');

                    if (!params.sort.includes("pegawai_status_id")) {
                        params.sort =  params.sort.replace(/pegawai./g, 'simpeg_pegawais.');
                      }         
                }
         
               

                
                loadOptions.filter = processLoadArray(loadOptions.filter); //benerin format periode_absen
                if (loadOptions.filter) {
                    let temp = [];
                        if(loadOptions.filter.length<=0){
                            loadOptions.filter = [['gajis.pegawai_status_id', '=', 5], "and", ['gaji_periode_id', '=', route.query.id]];
                        }
                        temp = loadOptions.filter;
                    
                    params.filter = JSON.stringify(temp);
                    params.filter =  params.filter.replace(/riwayat_pekerjaan/g, 'riwayat_pekerjaans');

                   // if (!params.filter.includes("pegawai_status_id")) {
                        // params.filter =  params.filter.replace(/pegawai./g, 'simpeg_pegawais.');
                    //  } 
                }
                if (loadOptions.skip) {
                    params.skip = loadOptions.skip;
                }
                if (loadOptions.take) {
                    params.take = loadOptions.take;
                }

               

                const response = await axios.get(`${API_BASE_URL}/customstore-gajis`, {
                    params: params,
                    headers: {
                        Authorization: api.defaults.headers.common['Authorization'],
                        'Content-Type': 'application/json',
                    },
                });

                
                latestAccessTime.value = null;
                // summary.value = null;
              
                if (response.data) {

                    summary.value = response.data.summary;
                    return {
                        data: response.data.data,
                        totalCount: response.data.totalCount,
                        summary: response.data.summary
                    };
                }

                throw 'Data loading error';
            },
        });


   
          
       

        function processLoadArray(loadArray) {
            return _.map(loadArray, item => {
                if (_.isArray(item)) {
                    // Check if 'periode_absen' is present in the sub-array
                    if (_.includes(item, 'periode_absen')) {
                        // Map through the sub-array to find and convert Date objects
                        return _.map(item, subItem => {
                            return subItem instanceof Date ? formatDateToISOString(subItem) : subItem;
                        });
                    } else {
                        // Recursively process nested arrays
                        return processLoadArray(item);
                    }
                }
                return item;
            });
        }



        function formatDateToISOString(date) {
            function pad(n) { return n < 10 ? '0' + n : n }
            return date.getFullYear() + '-' +
                pad(date.getMonth() + 1) + '-' +
                pad(date.getDate());
        }


        return {
            direksiCustomStore,
            tetapCustomStore,
            honorCustomStore,
            kontrakCustomStore,
            summary,
            latestAccessTime,
            // selectedBulanBacaDataGrid,
           
        }
    });